import { render, staticRenderFns } from "./qc-pmptsp.vue?vue&type=template&id=3f884338&scoped=true"
import script from "./qc-pmptsp.vue?vue&type=script&lang=js"
export * from "./qc-pmptsp.vue?vue&type=script&lang=js"
import style0 from "./qc-pmptsp.vue?vue&type=style&index=0&id=3f884338&prod&lang=scss"
import style1 from "./qc-pmptsp.vue?vue&type=style&index=1&id=3f884338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f884338",
  null
  
)

export default component.exports